import { Component, Input, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import {environment} from "../../../../environments/environment";
@Component({
  selector: 'app-detail-post',
  templateUrl: './detail-post.component.html',
  styleUrls: ['./detail-post.component.scss']
})
export class DetailPostComponent implements OnInit {
  
  @Input('post')  post:any | any;
  @Input('statInfoSal')  statInfoSal:any | any;
  @Input('statInfoComment')  statInfoComment:any | any;
  @Input('statInfoJob')  statInfoJob:any | any;
  imageName: string | undefined = '';
  selected: boolean = false;
  url_photo: String;
    // @ts-ignore
    public modalRef: BsModalRef;
    modelIsClosed: boolean = false;
    
    whenClickForChangeImage: boolean=false;
  constructor(private modalService: BsModalRef) { }

  ngOnInit(): void {
    this.url_photo = environment.url_photo;
    // console.log("****************************", this.statInfoSal)
  }


  public onClose(): void {
    this.whenClickForChangeImage = false;
    this.modelIsClosed = true;
    this.modalService.hide();
  }

  
  getUrlPhoto() {
    this.imageName = this.post.postSubProducts[0].subProduct?.photo;
    if(this.imageName != null || this.imageName != undefined){
      this.selected = true;
    }else {
      this.selected = false;
    }
  }

  getUrlPhoto1() {
    if(this.post.postSubProducts[0].subProduct?.photo1)
    this.imageName = this.post.postSubProducts[0].subProduct?.photo1;
    if(this.imageName != null || this.imageName != undefined){
      this.selected = true;
    }else {
      this.selected = false;
    }
  }

  getUrlPhoto2() {
    if(this.post.postSubProducts[0].subProduct?.photo2)
    this.imageName = this.post.postSubProducts[0].subProduct?.photo2;
    if(this.imageName != null || this.imageName != undefined){
      this.selected = true;
    }else {
      this.selected = false;
    }
  }

}
